export { default as ServerIntlProvider } from "i18n/ServerIntlProvider";
export {
    locales,
    type LocaleType,
    defaultLocale,
    i18nConfig,
} from "i18n/i18nConfig";
